import script from "./AuthTopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthTopNav.vue?vue&type=script&setup=true&lang=js"

import "./AuthTopNav.vue?vue&type=style&index=0&id=1bf8e54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf8e54c"]])

export default __exports__